import { getErrorHandler } from '@office-start/error-handler';
import { createGuid } from '@office-start/guid-generator';
import { logFeature } from '@office-start/telemetry-service';
import { getRequestIdFromResponse, httpPost } from '@office-start/xhr-service';
import { clientRequestIdHeader, headerDiagnostics } from '../models/Constants';
import { getServerDebugInfoString } from '../utilities/getServerDebugInfoString';
import { createRequestConfig } from './createRequestConfig';
export function postRequest(apiPath, requestData, eventName, otelEventName, baseRequestApiOptions, queryString) {
    var requestId = createGuid();
    var objectId = baseRequestApiOptions.objectId, tenantId = baseRequestApiOptions.tenantId, iceApplicationId = baseRequestApiOptions.iceApplicationId, aadAppId = baseRequestApiOptions.aadAppId, jwtAuthEnabled = baseRequestApiOptions.jwtAuthEnabled, getAccessToken = baseRequestApiOptions.getAccessToken, officeHomeApiRoot = baseRequestApiOptions.officeHomeApiRoot, correlationId = baseRequestApiOptions.correlationId, substrateApiEndpoint = baseRequestApiOptions.substrateApiEndpoint, edgeworthApiRootPath = baseRequestApiOptions.edgeworthApiRootPath, currentPage = baseRequestApiOptions.currentPage;
    var requestConfig = createRequestConfig(objectId, tenantId, iceApplicationId, currentPage, aadAppId, requestId);
    var requestUrl = "".concat(substrateApiEndpoint).concat(edgeworthApiRootPath).concat(apiPath);
    if (queryString) {
        requestUrl = "".concat(requestUrl, "?").concat(queryString);
    }
    return httpPost(eventName, otelEventName, requestUrl, requestData, requestConfig, jwtAuthEnabled, getAccessToken, officeHomeApiRoot, correlationId, 'Substrate', {
        populateRequestEvent: function (response, params) {
            params["EventType" /* InstrumentationParam.EventType */] = 'Request';
            params["RequestId" /* InstrumentationParam.RequestId */] =
                getRequestIdFromResponse(response) || '';
            params["DebugInfo" /* InstrumentationParam.DebugInfo */] =
                getServerDebugInfoString(response);
            params["ImpressionId" /* InstrumentationParam.ImpressionId */] =
                (response.headers &&
                    response.headers[clientRequestIdHeader]) ||
                    requestId;
            params["Diagnostics" /* InstrumentationParam.Diagnostics */] =
                response.headers && response.headers[headerDiagnostics];
            var featureParams = params;
            logFeature({
                featureName: "Edgeworth" /* KnownFeatureNames.Edgeworth */,
                eventName: otelEventName,
                params: featureParams,
            });
            delete params["EventType" /* InstrumentationParam.EventType */];
        },
    }).catch(function (error) {
        // TODO: Do we need to use error handler?
        getErrorHandler().handleError(error);
        throw error;
    });
}
//# sourceMappingURL=postRequest.js.map